<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
      <Menu mode="horizontal" style="padding:0 40px" active-name="1">
          <MenuItem name="1" :to="{name:'purviewGroup'}">
              权限组设置
          </MenuItem>
          <MenuItem name="2" :to="{name:'purviewRole'}">
              用户管理
          </MenuItem>
          <!--<MenuItem name="3" :to="{name:'purviewProject'}">-->
              <!--项目权限-->
          <!--</MenuItem>-->
        <div style="position: relative;display: inline-block" v-if="$route.name == 'purviewRole'">
          <Input class="search" v-model="searchText" placeholder="搜索项目名称/客户名称/主体名称"></Input>
          <div
              @click="searchTimes++"
              style="line-height:28px;background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top:17px;text-align: center;left: 310px;cursor:pointer;">
            <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
          </div>
        </div>
        <div style="position: relative;display: inline-block;float: right;">
            <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: sub;"/>
            <p class="catalog" @click="createPanel = true">新建</p>
        </div>
      </Menu>
      <router-view :createPanel="createPanel" :searchText="searchText" :searchTimes="searchTimes" @changePanelState="setPanelState" style="padding:0 40px 40px 40px;background-color:white"></router-view>
  </div>
</template>

<script>
  export default {
    name: "purview",
    data:function () {
      return {
        createPanel:false,
        searchText:'',
        searchTimes:0,
      }
    },
    methods:{
      setPanelState:function (val) {
        this.createPanel = val
      },
      search:function () {

      },
    }
  }
</script>

<style scoped>
  .search >>> .ivu-input {width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .notice-background{background: url("/img/sys/bg12.png");height: 140px;}
  .catalog{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 60px;cursor: pointer;}
</style>
